import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import {
  GroupMemberWithRelationsDto,
  ResponseDto,
  QueryParamsDto,
} from "@mimber/schema"
import { groupMembersKeys } from "../group-members.utils"

/**
 * Hook for fetching group members
 */
export const useGroupMembers = (
  groupUuid: string,
  params?: QueryParamsDto,
  options?: UseQueryOptions<ResponseDto<GroupMemberWithRelationsDto[]>, Error>
): UseQueryResult<ResponseDto<GroupMemberWithRelationsDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useGroupMembers")

  const { server } = useServerContext()

  return useQuery({
    queryKey: groupMembersKeys.findAll(groupUuid, params),
    queryFn: async () => {
      const response = await server.get<
        ResponseDto<GroupMemberWithRelationsDto[]>
      >(buildQueryString(`groups/${groupUuid}/members`, params))
      return response.data
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!groupUuid,
    ...options,
  })
}
